import React, { Component } from "react";
import { getWarehouseStocks } from "../../../../services/inventory/warehouseService";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { formatDate } from "../../../../utils/utils";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import withGlobalData from "../../common/withGlobalData";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
class SearchWarehouseStocks extends Component {
  state = {
    reload: this.props.globalData.reload,
    open: false,
    stocks: [],
  };

  componentDidMount() {
    this.getWarehouseStocksData();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getWarehouseStocksData();
      this.setState({ reload: globalData.reload });
    }
  }

  async getWarehouseStocksData() {
    const {
      warehouseID: warehouseIDprop = 0,
      itemID,
      varCode,
      match,
    } = this.props;
    let warehouseID = 0;
    if (warehouseIDprop > 0) {
      warehouseID = warehouseIDprop;
    } else {
      warehouseID = parseInt(match.params.warehouseID);
    }
    if (warehouseID > 0) {
      const response = await getWarehouseStocks(warehouseID, itemID, varCode);
      const { data } = response.data;
      this.setState({ stocks: data.warehouseStocks });
    }
  }

  render() {
    const { stocks } = this.state;
    const { onSelectStock } = this.props;

    return (
      <React.Fragment>
        <CustomDataTableSearch
          data={stocks}
          onRefreshData={() => {
            this.getWarehouseStocksData();
          }}
          onSelectedData={(rowData, originalEvent) => {
            if (onSelectStock) {
              onSelectStock(rowData);
            }
          }}
          columns={[
            {
              field: "select",
              body: (rowData) => (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-label-success btn-sm btn-pill btn-bold"
                    onClick={() => {
                      if (onSelectStock) {
                        onSelectStock(rowData);
                      }
                    }}
                  >
                    Select <i className="fas fa-angle-double-right"></i>
                  </button>
                </React.Fragment>
              ),
            },
            {
              header: "Item Type",
              field: "itemTypeName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
              hidden: true,
            },
            {
              header: "Item Code",
              field: "itemCode",
              body: (rowData) => (
                <React.Fragment>
                  {rowData.itemType > 0 ? (
                    <span>
                      <BootstrapTooltip title={rowData.itemTypeName}>
                        <span className="mr-2">
                          <i
                            className={
                              rowData.itemType === 1
                                ? "fas fa-boxes text-success"
                                : rowData.itemType === 2
                                ? "fas fa-tools text-primary"
                                : rowData.itemType === 3
                                ? "fas fa-building text-info"
                                : rowData.itemType === 4
                                ? "fas fa-boxes text-warning"
                                : rowData.itemType === 5
                                ? "fas fa-boxes text-danger"
                                : null
                            }
                          ></i>
                        </span>
                      </BootstrapTooltip>
                      <span>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                          displayInline
                        />
                      </span>
                    </span>
                  ) : (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
                    </React.Fragment>
                  )}
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "Item Name",
              field: "itemName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                </React.Fragment>
              ),
              sortable: true,
            },
            {
              header: "Quantity",
              field: "qty",
              body: (rowData) => (
                <div>
                  {rowData.qty} {rowData.uomName}
                </div>
              ),
              sortable: true,
            },
            {
              header: "Unit",
              field: "uomName",
              body: null,
              sortable: true,
              hidden: true,
            },
            {
              header: "Batch ID",
              field: "batchID",
              body: null,
              sortable: true,
            },
            {
              header: "Production Date",
              field: "productionDate",
              body: (rowData) => formatDate(rowData.productionDate),
              sortable: true,
            },
            {
              header: "Expiry Date",
              field: "expiryDate",
              body: (rowData) => formatDate(rowData.expiryDate),
              sortable: true,
            },
          ]}
        />
      </React.Fragment>
    );
  }
}

export default withGlobalData(SearchWarehouseStocks);
